import React, { Component } from 'react';

class MRPAssistanceItems extends Component {

    componentDidMount() {
    }

    ChangePropInModel = (propModel, value) => {
        const { SearchItemModel, ChangeAnyPropInstate } = this.props
        SearchItemModel[propModel] = value;
        ChangeAnyPropInstate("searchItemModel", SearchItemModel);
    }


    render() {
        const { ListItemsGroup, SearchItemModel, ChargeItemsInTabAsMayBeFilters, CloseActions } = this.props;
        return (
            <div className="modal fade" id="MRPAssistanceItemsModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="MRPAssistanceItemsModal" aria-hidden="true" >
                <div className="modal-dialog modal-lg modal-dialog-centered" >
                    <div className="modal-content">
                        <div className="modal-header" style={{ background: "#343a40" }}>
                            <h5 style={{ color: "white" }}>Lista de articulos: Criterios de seleccion</h5>
                            <button type="button" className="close" style={{ color: "white" }} onClick={() => CloseActions()} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className='row'>

                                <div className='col-4'>

                                    <div className="input-group mt-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"><strong>Desde: </strong></span>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={SearchItemModel && (SearchItemModel.from ?? '')}
                                            onChange={(event) => this.ChangePropInModel("from", event.target.value)}
                                            onKeyDown={(ev) => {
                                                if (ev.key === 'Enter') {
                                                    ChargeItemsInTabAsMayBeFilters();
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='col-4'>
                                    <div className="input-group mt-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"><strong>Hasta: </strong></span>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={SearchItemModel && (SearchItemModel.to ?? '')}
                                            onChange={(event) => this.ChangePropInModel("to", event.target.value)}
                                            onKeyDown={(ev) => {
                                                if (ev.key === 'Enter') {
                                                    ChargeItemsInTabAsMayBeFilters();
                                                }
                                            }}

                                        />
                                    </div>
                                </div>
                                <div className='col-4'>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-8'>
                                    <div className="input-group mt-3">
                                        <div className='input-group-prepend'>
                                            <span className='input-group-text'><strong>Todos:</strong></span>
                                        </div>
                                        <select
                                            name="select"
                                            className="form-control"
                                            value={SearchItemModel && (SearchItemModel.itmGrp ?? '')}
                                            onChange={(event) => this.ChangePropInModel("itmGrp", event.target.value)}
                                            style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                        >
                                            <option value="">Todos</option>
                                            {ListItemsGroup && ListItemsGroup.map(itemGrp => {
                                                return (
                                                    <option value={itemGrp.ItmsGrpCod}>{`${itemGrp.ItmsGrpNam}`}</option>
                                                )
                                            })}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer text-left">
                            <button type="button" className="btn btn-secondary" onClick={() => CloseActions()}>Cancelar</button>
                            <button type="button" className="btn btn-primary" onClick={() => ChargeItemsInTabAsMayBeFilters()}>OK</button>
                        </div>
                    </div>
                </div>


            </div>
        );
    }
}

export default MRPAssistanceItems;